export function manageDropdownHover() {
  const dropdownLinks = document.querySelectorAll('.level-1 > .menu-item-has-children > a');

  dropdownLinks.forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      dropdownLinks.forEach(otherLink => {
        if (otherLink !== link) {
          otherLink.parentElement.classList.remove('hover');
        }
      });

      this.parentElement.classList.toggle('hover');
    });
  });
  const offcanvasNav = document.querySelector('.offcanvas-navigation');
  const mainMenu = document.querySelector('.offcanvas-menu.level-0');
  const defaultHeight = (mainMenu) ? mainMenu.scrollHeight + 'px' : 'auto'; // Ausgangshöhe ermitteln

  // Die Ausgangshöhe als Standard setzen
  offcanvasNav.style.height = defaultHeight;

  const menuItemsWithChildren = document.querySelectorAll(".menu-item-has-children.offcanvas-menu__link, .menu-item-has-children > .offcanvas-menu__link");
  menuItemsWithChildren.forEach(function (item) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      const submenu = item.nextElementSibling;

      if (submenu && (submenu.classList.contains("level-1") || submenu.classList.contains("level-2"))) {
        submenu.classList.toggle("show");
        adjustOffcanvasHeight(submenu);
      } else if (item.parentElement.classList.contains("menu-item-has-children")) {
        const parentSubmenu = item.parentElement.querySelector('.offcanvas-menu__sublist');
        if (parentSubmenu) {
          parentSubmenu.classList.toggle("show");
          adjustOffcanvasHeight(parentSubmenu);
        }
      }
      menuItemsWithChildren.forEach(otherItem => {
        const otherSubmenu = otherItem.parentElement.querySelector('.offcanvas-menu__sublist');
        if (otherItem !== item && otherSubmenu && otherSubmenu !== submenu) {
          otherSubmenu.classList.remove("show");
        }
      });
    });
  });

  const backButtons = document.querySelectorAll(".offcanvas-menu__back");
  backButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      let parentSubmenu = button.closest(".level-1, .level-2");
      if (parentSubmenu) {
        parentSubmenu.classList.remove("show");
        adjustOffcanvasHeight(parentSubmenu, true);
      }
    });
  });

  function adjustOffcanvasHeight(submenu, isClosing = false) {
    if (!isClosing) {
      // Nur wenn das Untermenü geöffnet wird, passen wir die Höhe an
      const submenuHeight = Math.max(parseInt(defaultHeight), submenu.scrollHeight);
      offcanvasNav.style.height = `${submenuHeight}px`;
    } else {
      // Wenn ein Menü geschlossen wird, setzen wir die Höhe auf die Standardhöhe zurück
      offcanvasNav.style.height = defaultHeight;
    }
  }
}
